<template>
  <span class="badge badge-radio">Radio mode</span>
</template>

<script>
export default {
  name: "RadioMode"
}
</script>

<style scoped>

</style>